// The product name is not final (docs/naming.md). Everything that shows it reads this one constant:
// the app, the document title, the manifest (vite.config.ts writes it) and the service worker.
export const PRODUCT_NAME = "Whistle";

/** One short line used in the manifest and the install prompt. */
export const PRODUCT_TAGLINE = "Answer your coding agents from your phone.";

/** Theme colours used by the manifest and the <meta name="theme-color"> tags. Keep in step with styles.css. */
export const THEME_LIGHT = "#f1f2ef";
export const THEME_DARK = "#101416";
